import { GearInstance, StepperStep, CustomerOptionListItem } from 'types';
import { getSimpleLengthErrorMessage } from 'utils/validators';

export const getMainInfoStep = (
  instance: GearInstance,
  activities: CustomerOptionListItem[],
  brands: CustomerOptionListItem[],
  categories: CustomerOptionListItem[],
  markets: CustomerOptionListItem[],
  onPass: (data: any) => void,
): StepperStep => ({
  stepName: 'Configuration',
  onPass: async (data: any) => {
    onPass(data);
  },
  formProps: {
    buttonCaption: 'Next',
    withFooter: true,
    buttonsShape: 'slimy',
    alignButtons: 'alignRight',
    marginMode: "none",
    fields: [
      {
        type: 'secondTitle',
        fieldName: 'secondTitle',
        value: 'Gear Configuration',
      },
      {
        type: 'text',
        fieldName: 'title',
        label: 'Title',
        placeholder: 'Brand, model, size, gender',
        isThin: true,
        value: instance.title,
        required: true,
        starRequiredLabel: true,
        validator: (value) => getSimpleLengthErrorMessage(value, 1, 255),
      },
      {
        type: 'productCategoryBlock',
        fieldName: 'productCategoryBlock',
        value: instance,
        selectItems: activities,
      },
      {
        type: 'brandSelectionBlock',
        options: brands,
        value: instance.brand_id,
      },
    ],
  },
});
